import React from 'react';
import './index.less';

function PayoutActionButton({ children, onClick, isDisabled = false }) {
	return (
		<button
			className='payout-table--body--action-button'
			onClick={onClick}
			disabled={isDisabled}
		>
			{children}
		</button>
	);
}

export default PayoutActionButton;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-action-button/index.js